import ossApi from '../services/oss-api';
import {ENV_CONFIGS} from '../constants/envs';
import {getACMHeaders} from './acm-helpers';

import {getBlob} from './blob-helpers';

const uploadFileAsOssObjectToS3 = ({urn, token, data, acmHeaders, uploadConfig}) =>
  ossApi.getSignedS3UploadUrl({urn, token, acmHeaders}).then(({data: {urls: [url], uploadKey}}) =>
    ossApi
      .uploadBinaryData({url, data, config: uploadConfig})
      .then(() => ossApi.finalizeS3Upload({urn, token, uploadKey, acmHeaders}))
  );

export const uploadThumbnail = (urn, token, thumbnail) => {
  const acmHeaders = {'x-ads-acm-namespace': ENV_CONFIGS.ACM_NAMESPACE};
  return uploadFileAsOssObjectToS3({urn, token, data: thumbnail, acmHeaders});
};

export const uploadAttachment = (urn, token, data, projectScope, onUploadProgress) => {
  const acmHeaders = getACMHeaders(projectScope);
  return uploadFileAsOssObjectToS3({
    urn,
    token,
    data,
    acmHeaders,
    uploadConfig: {
      onUploadProgress
    }
  });
};

export const downloadAttachmentContentsToBlob = ({attachment, token, mimeType, projectScope}) =>
  ossApi
    .getSignedS3DownloadUrl({
      urn: attachment.urn,
      token,
      acmHeaders: getACMHeaders(projectScope)
    })
    .then(({data}) => getBlob(data.url, mimeType));
